import { InjectionToken } from '@angular/core';

export const ADDRESS_SUGGEST_SCROLL_SELECTOR = new InjectionToken<string>('AddressSuggestScrollSelector');
